<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">DA Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <label>Name <require-sign /></label>
      <v-text-field
        v-model.trim="da.name"
        :error-messages="handleFieldErrors($v.da.name)"
        type="text"
        outlined
        dense
      ></v-text-field>
      <label>Township Group <require-sign /></label>
      <v-combobox
        v-model="da.township_group"
        :error-messages="handleFieldErrors($v.da.township_group)"
        outlined
        dense
        item-text="name"
        item-value="id"
        :items="townshipGroups"
      ></v-combobox>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="da.id" @click.prevent="emitDaData" class="form-btn">
        <v-icon left>mdi-edit</v-icon>
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitDaData" class="form-btn">
        <v-icon left>mdi-okay</v-icon>
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "../notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  components: { FormRequireNoti, RequireSign },

  mixins: [ValidationMixin],
  props: {
    da: {
      type: Object,
      default: () => {
        return {
          name: null,
          township_group: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    da: {
      name: {
        required,
      },
      township_group: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("TownshipGroup", ["townshipGroups"]),
  },
  methods: {
    emitDaData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.da.name,
          township_group_id: this.da.township_group.id,
        };

        this.da.id ? (data.id = this.da.id) : false;

        this.$emit("emitDaData", data);

        this.da.name = null;
        this.da.township_group = null;
        this.$v.$reset();
      }
    },
  },
  created() {
    this.$store.dispatch("TownshipGroup/getTownshipGroups");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
